import React from 'react';
import {classes} from './TotalsSkeleton.st.css';
import {SkeletonSection} from '../../../../common/components/Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../../../common/components/Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../../../common/components/Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';

export const TotalsSkeleton = () => (
  <div className={classes.asideSkeleton}>
    <SkeletonSection>
      <SkeletonRow>
        <SkeletonLineWrapper size="medium" />
        <SkeletonLineWrapper size="small" />
      </SkeletonRow>
      <SkeletonRow>
        <SkeletonLineWrapper size="large" />
        <SkeletonLineWrapper size="small" />
      </SkeletonRow>
      <SkeletonRow>
        <SkeletonLineWrapper size="medium" />
        <SkeletonLineWrapper size="small" />
      </SkeletonRow>
    </SkeletonSection>
    <div className={classes.divider} />
    <SkeletonSection>
      <SkeletonRow>
        <SkeletonLineWrapper size="medium" />
        <SkeletonLineWrapper size="small" />
      </SkeletonRow>
    </SkeletonSection>
  </div>
);
